import classNames from "classnames";
import React from "react";
import "./BFFormSteps.scss";

export type BFFormStepProps = {
  preTitle?: string;
  title: string;
  description: string;
  render: (disabled: boolean) => React.ReactElement;
  disabled?: boolean;
};
interface BFFormStepsProps {
  steps: BFFormStepProps[];
  stepInfoWidth: number;
}
const BFFormSteps = (props: BFFormStepsProps) => {
  const [focusedIndex, setFocusedIndex] = React.useState(0);
  return (
    <div className={classNames(`bf-form-steps`)}>
      {props.steps.map((step, index) => {
        return (
          <BFFormStep
            {...step}
            stepInfoWidth={props.stepInfoWidth}
            focused={index === focusedIndex}
            onFocusStep={() => setFocusedIndex(index)}
          />
        );
      })}
    </div>
  );
};

export default BFFormSteps;

const BFFormStep = (
  props: BFFormStepProps & {
    stepInfoWidth: number;
    focused?: boolean;
    onFocusStep: () => void;
  }
) => {
  const ref = React.useRef<HTMLDivElement>(null);

  return (
    <div
      className={classNames(`bf-form-step`, {
        focused: props.focused,
        disabled: props.disabled,
      })}
      onFocus={() => {
        if (ref.current?.contains(document.activeElement)) {
          props.onFocusStep();
        }
      }}
      ref={ref}
    >
      <div className={`step-info`} style={{ width: props.stepInfoWidth }}>
        {props.preTitle && (
          <div className={`step-pre-title`}>{props.preTitle}</div>
        )}
        <div className={`step-title`}>{props.title}</div>
        <div className={`step-description`}>{props.description}</div>
        <div className={classNames(`step-divider`)}></div>
      </div>
      <div
        className={`step-content`}
        style={{ width: `calc(100% - ${props.stepInfoWidth}px)` }}
      >
        {props.render(props.disabled)}
      </div>
    </div>
  );
};
